export default "__VITE_ASSET__CDHbhsEo__"